import gsap, { wrap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

class Animation {
  constructor() {
    this.parallax();
    this.contentParallax();
  }

  parallax() {
    const images = document.querySelectorAll(".parallax");

    if (images) {
      images.forEach((p) => {
        const isDesktopOnly = p.classList.contains("parallax-desktop");

        if (isDesktopOnly && innerWidth < 700) return;

        const image = p.querySelector("img");
        gsap.to(image, {
          yPercent: 25,
          scrollTrigger: {
            scrub: true,
            trigger: p,
            start: "top bottom",
            end: "bottom top",
          },
        });
      });
    }
  }

  contentParallax() {
    const images = document.querySelectorAll(
      ".bt-blog-detail__featured img, .bt-blog-detail__related-media img, " +
        ".bt-journal-feature__media img, .bt-journal-card__media img, " +
        ".bt-place-card > img, .bt-tour-row > img, .bt-car-card__vehicle, " +
        ".bt-reservation-car__media img, .bt-reservation-summary__vehicle-media img",
    );

    images.forEach((image) => {
      const frame = image.parentElement;
      const isContainedVehicle = image.classList.contains("bt-car-card__vehicle");
      if (frame && frame.matches(
        ".bt-blog-detail__featured, .bt-blog-detail__related-media, " +
          ".bt-journal-feature__media, .bt-journal-card__media, " +
          ".bt-reservation-car__media, .bt-reservation-summary__vehicle-media",
      )) {
        frame.classList.add("bt-parallax-media");
      }

      gsap.fromTo(
        image,
        { yPercent: isContainedVehicle ? -2 : -4, scale: isContainedVehicle ? 1.02 : 1.06 },
        {
          yPercent: isContainedVehicle ? 2 : 4,
          scale: isContainedVehicle ? 1.04 : 1.1,
          ease: "none",
          scrollTrigger: {
            trigger: frame || image,
            start: "top bottom",
            end: "bottom top",
            scrub: true,
          },
        },
      );
    });
  }
}

const animateStagger = () => {
  const elem = document.querySelectorAll(".stagger-trigger");
  if (elem) {
    elem.forEach((item) => {
      const child = item.children;

      ScrollTrigger.create({
        trigger: item,
        start: "top top+=70%",
        once: true,
        onEnter: () => {
          gsap.to([...child], {
            y: 0,
            opacity: 1,
            duration: 1,
            stagger: 0.07,
            ease: "power4.out",
          });
        },
      });
    });
  }
};

const animateStaggerPartnerLogo = () => {
  const partner = document.querySelector(".partners .brand");
  const mobileWrapper = document.querySelector(".partners .brand-wrapper");

  if (partner) {
    const brand = partner.querySelectorAll("figure");

    if (brand) {
      brand.forEach((b) => {
        if (innerWidth > 800) {
          gsap.set(b, { opacity: 0 });
        }
      });

      if (innerWidth < 800) {
        if (mobileWrapper) {
          const orBrand = mobileWrapper.querySelector(".brand");
          const orBrandRect = orBrand.getBoundingClientRect();

          gsap.to(mobileWrapper, {
            x: orBrandRect.width * -1,
            duration: 10,
            ease: "none",
            repeat: -1,
          });
        }
      } else {
        ScrollTrigger.create({
          trigger: partner,
          start: "top center+=40%",
          once: true,
          onEnter: () => {
            gsap.to([...brand], {
              opacity: 1,
              duration: 1.6,
              stagger: 0.05,
              ease: "power4.out",
            });
          },
        });
      }
    }
  }
};

const setFullHeightMobile = () => {
  const elements = document.querySelectorAll(".full-height");
  const header = document.querySelector("header");

  if (innerWidth > 378) return;

  if (elements) {
    elements.forEach((el) => {
      const headerRect = header.getBoundingClientRect();
      el.style.height = `${innerHeight}px`;
    });
  }
};

const infiniteLoops = () => {
  const heroCardEvent = document.querySelector(".bb-herobanner .card-events");
  document.querySelectorAll(".infinite-loop").forEach((wrapper) => {
    const track = wrapper.querySelector(".track");
    const mobileOnly = wrapper.dataset.mobile;
    const innerWrapper = wrapper.querySelector(".track-wrapper");

    const isQuoteListing = wrapper.classList.contains("quote-listings");

    if (mobileOnly === "1" && innerWidth > 700) return;
    if (track && innerWrapper && !innerWrapper.classList.contains("no-loop")) {
      for (let i = 0; i < 3; i++) {
        const cloneTrack = track.cloneNode(true);
        innerWrapper.appendChild(cloneTrack);
      }
    }

    if (isQuoteListing && innerWidth < 700) {
      const tracks = wrapper.querySelectorAll(".track");

      if (tracks) {
        tracks.forEach((item) => {
          const card = item.querySelectorAll(".card");
          if (!card.length) return;
          const rect = card[0].getBoundingClientRect();
          const width = rect.width;
          // console.log("children", children);

          item.style.minWidth = `${(width + 36) * card.length}px`;
          item.style.maxWidth = `${(width + 36) * card.length}px`;
        });
      }
    }
    // Set flag active for slider
    if (innerWrapper) innerWrapper.classList.add("active");
  });

  if (heroCardEvent) {
    heroCardEvent.addEventListener("touchstart", () => {
      heroCardEvent.classList.add("touch-start");
      heroCardEvent.querySelector(".track-wrapper").classList.add("pause");
    });

    heroCardEvent.addEventListener("touchend", () => {
      heroCardEvent.classList.remove("touch-start");
      heroCardEvent.querySelector(".track-wrapper").classList.remove("pause");
    });
  }
};

const animationMouseFollow = () => {
  document.querySelectorAll(".mouse-follow").forEach((el) => {
    const isShadow = el.classList.contains("shadow");

    let currentX = 0;
    let currentY = 0;
    let targetX = 0;
    let targetY = 0;

    const speed = 0.08;

    // Phone disabled
    if (innerWidth < 700) return;

    const animate = () => {
      currentX += (targetX - currentX) * speed;
      currentY += (targetY - currentY) * speed;

      if (isShadow) {
        // shadow lebih dramatis + opposite direction
        el.style.transform = `translate3d(${currentX}px, ${currentY}px, 0)`;
      } else {
        // object subtle follow
        el.style.transform = `translate3d(${currentX}px, ${
          currentY * 0.3
        }px, 0)`;
      }

      requestAnimationFrame(animate);
    };

    animate();

    window.addEventListener("mousemove", (e) => {
      const rect = el.getBoundingClientRect();

      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;

      const dx = e.clientX - centerX;
      const dy = e.clientY - centerY;

      const distance = Math.hypot(dx, dy);
      const radius = Math.max(rect.width, rect.height) * 2.4;

      if (distance > radius) {
        targetX = 0;
        targetY = 0;
        return;
      }

      let intensity = 1 - distance / radius;
      intensity = Math.pow(intensity, 1.5);

      if (isShadow) {
        // 🔥 SHADOW = opposite direction + stronger offset
        targetX = -dx * intensity * 0.05;
        targetY = -dy * intensity * 0.05;
      } else {
        // ✨ object subtle follow
        targetX = dx * intensity * 0.05;
        targetY = dy * intensity * 0.05;
      }
    });
  });
};

const mapHover = () => {
  const location = document.querySelectorAll(".map .map-part");

  if (location && !isMobile) {
    const cards = document.querySelectorAll(".overview .overview-card");

    // Initial active

    location.forEach((item, index) => {
      const getLocationId = item.id;
      item.style.opacity = 0.4;

      if (item.id === "na") item.style.opacity = 1;

      item.addEventListener("mouseover", () => {
        location.forEach((m) => (m.style.opacity = 0.4));
        item.style.opacity = 1;

        if (mapSliderOverview) {
          const getId = [...cards].findIndex((m) => m.id === getLocationId);
          mapSliderOverview.slideTo(getId > -1 ? getId : index);
        }
      });

      // item.addEventListener("mouseout", () => {
      //   location.forEach((m) => (m.style.opacity = 1));
      // });
    });

    // Navigation
    const prevNextButton = document.querySelectorAll(
      ".map-location .prev-next-button",
    );

    if (prevNextButton) {
      prevNextButton.forEach((item) => {
        const isNext = item.classList.contains("next");
        item.addEventListener("click", () => {
          prevNextButton.forEach((b) => {
            b.classList.remove("disabled");
          });

          if (isNext) {
            mapSliderOverview.slideNext();
          } else {
            mapSliderOverview.slidePrev();
          }

          const getSlideActive =
            mapSliderOverview.slides[mapSliderOverview.activeIndex];

          const mapId = getSlideActive.id;

          [...location].forEach((m) => {
            m.style.opacity = 0.4;
            if (m.id === mapId) m.style.opacity = 1;
          });

          if (mapSliderOverview.isEnd)
            prevNextButton[1].classList.add("disabled");

          if (mapSliderOverview.activeIndex === 0)
            prevNextButton[0].classList.add("disabled");
        });
      });
    }
  }
};

const stickyNews = () => {
  const newsContainer = document.getElementById("news-listing");
  if (!newsContainer) return;
  const footer = document.querySelector("main");
  const rect = newsContainer.getBoundingClientRect();

  if (isMobile) return;
  ScrollTrigger.create({
    pin: newsContainer,
    trigger: "main",
    start: "top top",
    endTrigger: footer,
    end: `bottom bottom`,
  });
};

document.addEventListener("DOMContentLoaded", () => {
  animateStagger();
  animateStaggerPartnerLogo();
  setFullHeightMobile();
  mapHover();
  // Button animations
  // buttonAnimation();

  // Infinite loops
  setTimeout(() => {
    infiniteLoops();
  }, 1000);

  animationMouseFollow();

  stickyNews();

  new Animation();

  document.querySelectorAll(".reveal").forEach((el) => {
    // gsap.to(el, {
    //   y: 0,
    //   scale: 1,
    //   opacity: 1,
    //   duration: 0.56,
    //   ease: "power4.InOut",
    //   stagger: 0.05,
    //   scrollTrigger: {
    //     trigger: el,
    //     start: "top 90%", // 🔥 25% from the bottom of the viewport
    //   },
    // });
  });
});
